export default {"src":"/_next/static/media/mediawind_white.734a624b.svg","height":24,"width":181,"blurWidth":0,"blurHeight":0};